import firebase from 'src/utils/firebase';
import axios from 'axios';


export const validateEmail = async (email) => {
    try {
        const url = `${process.env.NEXT_PUBLIC_POS_URL}/api/validation`;
        const request = await axios.post(url, {
            data: { data: email },
            headers: {
              'Content-Type': 'application/json',
            }
          });

        return request.data.next;
    } catch (error) {
        console.log(' 4444444 ', error);
        return null;
    }
}


export const handleSignInWithEmailAndPassword = async (email, password) =>{
    try {
        const res = await firebase.auth().signInWithEmailAndPassword(email, password);
        return res;
    } catch (error) {
        if (error.code === 'auth/invalid-credential') return 'auth/invalid-credential';
        return null;
    }
}
